// extracted by mini-css-extract-plugin
module.exports = {"inputArea":"Confirmation_inputArea__3Iqxp","buttonArea":"Confirmation_buttonArea__1b2qK"};